import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Button } from 'app/design/primitives/button';
import { useScopedTranslation } from 'app/hooks/i18n';
import { ADDRESS_ICONS, theme } from './shared';

export const AddressIconPicker = ({
  onSelect,
  selectedIcon,
}: {
  onSelect: (icon: number) => void;
  selectedIcon: number;
}) => {
  const { t } = useScopedTranslation();
  return (
    <>
      <Text fontSize={16} fontWeight="700" marginTop="spacing.general.x2" variant="bodyBase">
        {t('iconLabel')}
      </Text>
      <Row gap="spacing.general.x1" justifyContent="center">
        {ADDRESS_ICONS.map(({ id, Icon }) => (
          <Button
            key={id}
            onPress={() => onSelect(id)}
            style={{
              backgroundColor: selectedIcon === id ? theme.colors['surface.tertiary'] : '#F7E9AB',
              borderRadius: theme.borderRadii['radius.sm'],
            }}
            width={47}
            height={47}
            alignItems="center"
            justifyContent="center"
          >
            <Icon size={30} strokeWidth={1.5} />
          </Button>
        ))}
      </Row>
    </>
  );
};
